import React from "react";
import "antd/dist/antd.css";
import "../../../css/mainContainer.css";
import { Layout } from "antd";
import { useTranslation } from "../../../hooks/useTranslation";
import { StyleSheet } from "../../../models/StyleSheet";
import { H3 } from "../..";

const { Header } = Layout;

export function TopBar() {
  const { t } = useTranslation("supplierReviews");
  return (
    <Header className="header" style={styles.header}>
      <div className="top-bar">
        <H3 text={t("supplierDocuments")} style={styles.topleftText} />
      </div>
      {/* <div style={styles.searchBar}>
        <Searchbar placeholder={"Search"} />
      </div> */}
    </Header>
  );
}

const styles = StyleSheet.create({
  header: {
    backgroundColor: "white",
  },
  link: {
    marginLeft: "32px",
    marginRight: "32px",
    lineHeight: "13.03px",
    color: "#000",
    textDecoration: "underline",
    marginBottom: "2px",
    fontSize: "20px",
  },
  topleftText: {
    marginLeft: "32px",
    marginRight: "32px",
    fontWeight: "700",
    lineHeight: "13.03px",
    color: "#000",
    marginBottom: "2px",
  },
  topRightLink: {
    marginLeft: 10,
    marginRight: 10,
  },
  icon: {
    width: "100%",
  },
  searchBar: {
    height: 32,
    marginBottom: 32,
  },
});
